module.exports = __webpack_public_path__ + "8d5a929b92bf3218ed131ebaac92f182.svg";